
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M8.5 1.5v14m7-7h-14"}})])
          )
        }
      }
    